// extracted by mini-css-extract-plugin
export default {"dataVisualizer":"ownership-data-import_dataVisualizer__nY3+0","columnSelector":"ownership-data-import_columnSelector__7cXwr"};